import React from 'react';
import { GiPerspectiveDiceSixFacesRandom } from 'react-icons/gi';

/**
 * RandomDrawIcon
 * Ikona kocky pre znázornenie prebiehajúceho žrebovania.
 */
const RandomDrawIcon = ({ className = 'inline-block align-middle', ...props }) => (
  <GiPerspectiveDiceSixFacesRandom className={className} {...props} />
);

export default RandomDrawIcon;

